import { Box } from "@jewlr/storybook/core"
import loadable from "@loadable/component"
import { Helmet } from "react-helmet-async"
import { Link } from "react-router-dom"
import styled from "styled-components"

import { retry } from "helpers/application"
import {
  LinkButton,
  SectionTitle,
  SectionDescription,
} from "jewlr/pages/components"

const StampedGetInspired = loadable(() =>
  retry(() => import("components/stamped-get-inspired"))
)

const ButtonBlackKeyline = styled(LinkButton).attrs({
  p: { _: "11px 26px", tablet: "16px 56px" },
})`
  border: solid 1px ${(props) => props.theme.colors.black};
  box-shadow: none;
`

const GetInspired = () => (
  <Box contain id="GetInspired" px={{ _: "5px" }} textAlign="center">
    <Helmet>
      <title>Get Inspired</title>
    </Helmet>
    <SectionTitle as="h1" mt={4} textAlign="center">
      Get Inspired
    </SectionTitle>
    <SectionDescription
      letterSpacing="2px"
      mx="auto"
      textAlign="center"
      width="85%"
    >
      See what our customers are creating. <br />
      Shop the look to personalize and make it yours.
    </SectionDescription>
    <StampedGetInspired />
    <ButtonBlackKeyline
      as={Link}
      data-lc="get-inspired"
      mb={{ _: 4, tablet: 2 }}
      mt={{ _: 2, tablet: 3 }}
      to="/personalized-jewelry"
    >
      SHOP ALL
    </ButtonBlackKeyline>
  </Box>
)

export default GetInspired
